import { IWebSearch } from "../types";

export function genFuzzyMatchingReg(keyword: string): RegExp | null {
  const escapeReg = /[.*+\-?^${}()|[\]\\]/;
  const searchStr = keyword
    .split("")
    .map(s => (escapeReg.test(s) ? `([\\${s}])` : `(${s})`));
  if (searchStr.length) {
    // console.log('searchStr', searchStr)
    const str = "(.*?)";
    const regStr = `${str}${searchStr.join(str)}(.*)`; // 尾部必须使用贪婪匹配
    const reg = RegExp(regStr, "i");
    return reg;
  } else {
    return null;
  }
}

export const formatWebSearchUrl = (web_search: IWebSearch[] = []) => {
  const arr = new Array(100);
  web_search.forEach(i => {
    arr[i.index] = i.url;
  });
  return arr;
};
